import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useLocation } from "react-router-dom";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import pageSEO from "../constants/pageSEO";
import { SEO } from "../components/seo.component";
import { useUserParams } from "../hooks/useUserParams";
import globalState from "../utils/globalState";

export default function About() {
  const { state } = useLocation();
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentHeadshot,
    getCurrentBrokerage,
    getCurrentAbout,
  } = useUserParams();
  const userData = globalState.getUserData();

  const seoConfig = pageSEO.about();

  const fullAboutSource =
    state?.bio ||
    userData?.fullAbout ||
    userData?.FULL_ABOUT ||
    userData?.about ||
    getCurrentAbout() ||
    constants.FULL_ABOUT;

  const fullAboutParagraphs = fullAboutSource
    ? fullAboutSource.split("<|>")
    : [];

  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] mx-auto gap-x-20 gap-y-10 px-6 grid sm:grid-cols-2 mb-12 min-h-[70vh] pt-[150px] min-[1100px]:pt-[200px]">
        <div>
          <img src={getCurrentHeadshot()} className="w-full " />
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black libre text-3xl">
              {getCurrentAgentName()}
            </h2>
            <p className="italic text-lg">
              {getCurrentAgentTitle()}, {getCurrentBrokerage()}
            </p>

            <div className="flex gap-x-5 my-2">
              {Object.entries(constants.SOCIALS ?? {})?.map(([k, v]) => (
                <a href={constants.SOCIALS[k]} key={k}>
                  <FontAwesomeIcon
                    className="fa-xl text-logo-third"
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
            <p className="font-semibold text-lg">
              <FontAwesomeIcon
                icon={faPhone}
                className="pr-2 text-logo-third"
              />
              {getCurrentAgentNumber()} {" "}
            </p>
            <p className="text-lg">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="pr-2 text-logo-third"
              />
              {getCurrentAgentEmail()} {" "}
            </p>
          </div>
        </div>
        <div>
          <h1 className="text-4xl text-black pb-8 libre ">About Me</h1>

          {fullAboutParagraphs.length ? (
            fullAboutParagraphs.map((p, index) => (
              <p key={index}>
                {p}
                <br />
                <br />
              </p>
            ))
          ) : (
            <p>Coming Soon</p>
          )}
        </div>
      </div>
    </>
  );
}
